<template>
  <div class="grid__autocolumns" :class="{'auto':auto}">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "GridAutoColumns",
  props: {
    auto: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped lang="scss">
.grid__autocolumns {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
  grid-column-gap: 2%;

  &.auto {
    grid-template-columns: repeat(auto-fit, minmax(100px, auto));
  }
}
</style>
